/**
 * Created by mac on 4/8/18
 */

const OKAds = function () {
    AdsPlugin.call(this, connector.OK, {
        sdk: SdkManager.SDK_OK,
        cantLoadAndPlayInParallel: true,
        cantLoadAfterPlay: true,
        customImpressionEvent: true
    });

    this.bannerPosition = "bottom";
};

OKAds.prototype = Object.create(AdsPlugin.prototype);
OKAds.prototype.constructor = OKAds;

OKAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.OK);
};

OKAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

OKAds.prototype.isStickySupported = function () {
    return true;
};

OKAds.prototype._checkAdBlock = function (callback) {
    connector.platform.getPlugin().listeners.isAdBlockEnabled = connector.utils.waitNoMore(200, (result, data) => {
        if (result === undefined && data === undefined) {
            this._checkAdBlock(callback);
            return;
        }

        callback(result === "ok" && data === "true");
    });

    FAPI.invokeUIMethod("isAdBlockEnabled");
};

OKAds.prototype.checkAdBlock = function (callback) {
    this._checkAdBlock(callback);
};

OKAds.prototype._connect = function (callback) {
    if (typeof FAPI === "undefined" || !FAPI.UI.showAd || !FAPI.UI.showLoadedAd) {
        callback(connector.STATUS_DISCONNECTED);
        return;
    }

    if (connector.info.isInApp) {
        const isNativeSupported = FAPI.UI.isNativeAdSupported && FAPI.UI.isNativeAdSupported();
        if (!isNativeSupported) {
            callback(connector.STATUS_DISCONNECTED);
            return;
        }
    }

    callback(connector.STATUS_CONNECTED);
};

OKAds.prototype._cacheAd = function (name, callback) {
    if (AdsPlugin.REWARDED === name) {
        this._cacheCallback = callback;
        this.cachedRewardedTime = Date.now();

        FAPI.UI.loadAd();
    } else if (AdsPlugin.INTERSTITIAL === name) {
        callback(connector.CODE_SUCCEED, true);
    }
};

OKAds.prototype._playAd = function (name, ad, callback) {
    if (name === AdsPlugin.REWARDED) {
        this._playRewardedCallback = callback;
        this.cachedRewardedTime = undefined;

        FAPI.UI.showLoadedAd();
    } else if (name === AdsPlugin.INTERSTITIAL) {
        this._playInterstitialCallback = callback;
        FAPI.UI.showAd();
    }
};

OKAds.prototype.isAdExpired = function (name) {
    return name === AdsPlugin.REWARDED && this.cachedRewardedTime < Date.now() - OKAds.REWARDED_EXPIRED_TIME;
};

OKAds.prototype.isLandscape = function () {
    return window.innerHeight < window.innerWidth;
};

OKAds.prototype.calcBannersCountMax = function () {
    if (!connector.info.isMobile && this.isLandscape() && this.bannersData.count_options && this.bannersData.count_options.includes(OKAds.AD_BANNERS_COUNT_MAX)) {
        return OKAds.AD_BANNERS_COUNT_MAX;
    }

    return OKAds.AD_BANNERS_COUNT_DEFAULT;
};

OKAds.prototype.initBannersData = function (f, stop) {
    connector.platform.getPlugin().listeners.getBannerFormats = connector.utils.once((code, data) => {
        if (code === "ok" && data) {
            this.bannersData = JSON.parse(data);

            if (!this.bannersData.current_count) {
                this.bannersData.current_count = 1;
            }
            f();
        } else {
            stop();
        }
    });

    FAPI.invokeUIMethod("getBannerFormats");
};

OKAds.prototype.setBannerPosition = function (position, f, stop) {
    const currentFormat = this.bannersData.current;
    const allowedPositions = OKAds.BANNER_FORMATS[currentFormat].positions;

    if (!allowedPositions.includes(position)) {
        console.log(
            `OkAds Invalid banner position "${position}" for format "${currentFormat}". `
                + `Allowed positions: ${allowedPositions.join(", ")}`
        );

        stop();
        return;
    }

    this.bannerPosition = position;
    console.log(`OKAds banner position set to: ${position}`);

    f();
};

OKAds.prototype.setBannerFormat = function (format, onSuccess, onFailure) {
    onSuccess = onSuccess || function () {};
    onFailure = onFailure || function () {};

    if (this.bannersData.current === format) {
        onSuccess();
        return;
    }

    if (!this.bannersData.supported[format]) {
        onFailure(ERRORS.SHOW_STICKY.NOT_SUPPORTED);
        return;
    }

    connector.platform.getPlugin().listeners.setBannerFormat = connector.utils.once((code, data) => {
        if (data === "set_banner_format_success" || (code === "ok" && data === "true")) {
            this.bannersData.current = format;
            onSuccess();
        } else {
            onFailure();
        }
    });

    FAPI.invokeUIMethod("setBannerFormat", format);
};

OKAds.prototype.initBannersCount = function (f, stop) {
    const countMax = this.calcBannersCountMax();
    if (this.bannersData.current_count === countMax) {
        f();
        return;
    }

    connector.platform.getPlugin().listeners.setBannersCount = connector.utils.once((c) => {
        if (c === "ok") {
            this.bannersData.current_count = countMax;
        }

        if (this.bannersData.current_count) {
            f();
        } else {
            stop();
        }
    });

    FAPI.invokeUIMethod("setBannersCount", countMax);
};

OKAds.prototype.getBannerSize = function () {
    const format = this.bannersData.current || "bar";
    const bannersCount = this.bannersData.current_count;

    const bannerSizes = OKAds.BANNER_FORMATS[format].sizes;

    let size = bannerSizes.default;
    if (connector.info.isMobile) {
        size = (this.isLandscape() || !bannerSizes.mobile)
            ? bannerSizes.mobile_landscape
            : bannerSizes.mobile;
    }

    if (bannersCount > 1) {
        const field = format.includes("vertical") ? "height" : "width";
        size[field] = size[field] === 0 ? 0 : size[field] * bannersCount + OKAds.AD_BANNERS_OFFSET * (bannersCount - 1);
    }

    return size;
};

OKAds.prototype.showSticky = function (callback, options) {
    const onSuccess = () => {
        callback(connector.CODE_SUCCEED, this.getBannerSize());
    };

    const player = new ConnectorActionPlayer([
        (f, stop) => this.initBannersData(f, stop),

        (f, stop) => {
            let format = options && options.format;
            if (!format) {
                format = connector.info.isMobile && this.isLandscape() ? "thin" : "bar";
            }

            this.setBannerFormat(format, f, stop);
        },

        (f, stop) => {
            if (options && options.position) {
                this.setBannerPosition(options.position, f, stop);
                return;
            }

            f();
        },

        (f, stop) => this.initBannersCount(f, stop),

        (f, stop) => this.requestBannerAds(f, stop),

        (f, stop) => {
            connector.platform.getPlugin().listeners.isBannerAdsVisible = connector.utils.once((code, data) => {
                if (code !== "ok") {
                    stop();
                } else if (data === "true") {
                    onSuccess();
                } else {
                    f();
                }
            });

            FAPI.invokeUIMethod("isBannerAdsVisible");
        },

        (f, stop) => {
            connector.platform.getPlugin().listeners.showBannerAds = connector.utils.once((code, data) => {
                if (code !== "ok") {
                    stop();
                    return;
                }

                if (data !== "true") {
                    stop(ERRORS.SHOW_STICKY.NO_STICKY);
                    return;
                }

                f();
            });

            FAPI.invokeUIMethod("showBannerAds", this.bannerPosition);
        }
    ]);

    player.onFailure((code) => {
        callback(code || ERRORS.SHOW_STICKY.UNKNOWN);
    });

    player.play(onSuccess);
};

OKAds.prototype.requestBannerAds = function (f, stop) {
    if (connector.platform.getPlugin().listeners.requestBannerAds) {
        f();
        return;
    }

    connector.platform.getPlugin().listeners.requestBannerAds = connector.utils.once((code) => {
        const requestBannerAds = (code, data) => {
            connector.platform.getPlugin().listeners.requestBannerAds = requestBannerAds;

            if (code === "ok" && data === "ad_shown") {
                if (!connector.ads.isStickyPlaying) {
                    connector._adsManager.onStickyRestored(this.getBannerSize());
                }

                this.bus.trigger("sticky:render");
                this.onImpressionEvent(AdsPlugin.STICKY);
            }

            if (data === "hidden_by_user") {
                connector._adsManager.onStickyClosedByUser();
            }
        };

        connector.platform.getPlugin().listeners.requestBannerAds = requestBannerAds;

        if (code === "ok") {
            f();
        } else {
            stop();
        }
    });

    FAPI.invokeUIMethod("requestBannerAds");
};

OKAds.prototype.closeSticky = function (callback) {
    connector.platform.getPlugin().listeners.hideBannerAds = connector.utils.once((code) => {
        if (code !== "ok") {
            callback(ERRORS.CLOSE_STICKY.UNKNOWN);
            return;
        }

        connector.platform.getPlugin().listeners.isBannerAdsVisible = connector.utils.once((code, data) => {
            if (code !== "ok") {
                callback(ERRORS.CLOSE_STICKY.UNKNOWN);
                return;
            }

            if (data !== "false") {
                callback(ERRORS.CLOSE_STICKY.UNKNOWN);
                return;
            }

            connector.platform.getPlugin().listeners.requestBannerAds = undefined;
            connector.platform.getPlugin().listeners.showBannerAds = undefined;
            connector.platform.getPlugin().listeners.hideBannerAds = undefined;
            connector.platform.getPlugin().listeners.isBannerAdsVisible = undefined;

            callback(connector.CODE_SUCCEED);
        });

        FAPI.invokeUIMethod("isBannerAdsVisible");
    });

    FAPI.invokeUIMethod("hideBannerAds");
};

OKAds.prototype.onSdkEvent = function (method, result, data) {
    switch (method) {
        case "loadAd":
            this.windowApiLoadAdCallbackRewarded(AdsPlugin.REWARDED, result, data);
            break;
        case "showLoadedAd":
            this.windowApiPlayAdCallbackRewarded(AdsPlugin.REWARDED, result, data);
            break;
        case "showAd":
            this.windowApiCallbackInterstitial(AdsPlugin.INTERSTITIAL, result, data);
            break;
    }
};

OKAds.prototype.windowApiLoadAdCallbackRewarded = function (name, result, data) {
    const callback = this._cacheCallback;
    if (!callback) {
        return;
    }

    if (result === "error") {
        this._cacheCallback = undefined;
        callback(OKAds.parseLoadError(data));
    } else if (["ad_prepared", "ready"].indexOf(data) !== -1) {
        this._cacheCallback = undefined;
        callback(connector.CODE_SUCCEED, true);
    }
};

// the platform answers loadAd errors with a reason in data (no_ads, call_limit, in_use, initialization_error, ...),
// kept in the loading error so ad_load_error metrics show it instead of one "failed"
OKAds.parseLoadError = function (data) {
    if (data === "no_ads") {
        return AdsPlugin.ERROR_LOADING_NO_ADS;
    }

    if (typeof data !== "string" || data === "" || data === "error") {
        return AdsPlugin.ERROR_LOADING_FAILED;
    }

    return `ads_loading_${data.toLowerCase().replace(/[^a-z0-9]+/g, "_").substring(0, 30)}`;
};

OKAds.prototype.windowApiPlayAdCallbackRewarded = function (name, result, data) {
    const callback = this._playRewardedCallback;
    if (!callback) {
        return;
    }

    if (["ad_prepared", "ready"].indexOf(data) !== -1) {
        // do nothing
    } else if (result === "error") {
        this._playRewardedCallback = undefined;

        if (data === "skip") {
            callback(ERRORS.SHOW_REWARDED.CLOSED_BY_USER);
        } else if (data === "ad_expired") {
            callback(ERRORS.SHOW_REWARDED.AD_EXPIRED);
        } else {
            callback(ERRORS.SHOW_REWARDED.UNKNOWN, data);
        }
    } else if (["ad_shown", "complete"].indexOf(data) !== -1) {
        this._playRewardedCallback = undefined;
        this.onImpressionEvent(name);
        callback(connector.CODE_SUCCEED);
    }
};

OKAds.prototype.windowApiCallbackInterstitial = function (name, result, data) {
    const callback = this._playInterstitialCallback;
    if (!callback) {
        return;
    }

    if (["ad_prepared", "ready"].indexOf(data) !== -1) {
        // do nothing
    } else if (result === "error" || ["no_ads", "skip"].indexOf(data) !== -1) {
        this._playInterstitialCallback = undefined;

        const code = this.parseInterstitialError(data);
        callback(code, code === ERRORS.SHOW_INTERSTITIAL.UNKNOWN ? data : undefined);
    } else if (["ad_shown", "complete"].indexOf(data) !== -1) {
        this._playInterstitialCallback = undefined;
        this.onImpressionEvent(name);

        callback(connector.CODE_SUCCEED);
    }
};

OKAds.prototype.parseInterstitialError = function (data) {
    switch (data) {
        case "skip":
            return ERRORS.SHOW_INTERSTITIAL.CLOSED_BY_USER;
        case "no_ads":
            return ERRORS.SHOW_INTERSTITIAL.NO_ADS;
        case "call_limit":
            return ERRORS.SHOW_INTERSTITIAL.THROTTLED;
        case "in_use":
            return ERRORS.SHOW_INTERSTITIAL.AD_ALREADY_RUNNING;
        case "initialization_error":
            return ERRORS.SHOW_INTERSTITIAL.AD_BLOCK;
        case "app_in_fullscreen":
        default:
            return ERRORS.SHOW_INTERSTITIAL.UNKNOWN;
    }
};

OKAds.AD_BANNERS_OFFSET = 16;

OKAds.AD_BANNERS_COUNT_DEFAULT = 1;
OKAds.AD_BANNERS_COUNT_MAX = 2;

OKAds.REWARDED_EXPIRED_TIME = connector.utils.parseInterval("14 minutes");

OKAds.BANNER_FORMATS = {
    bar: {
        positions: ["top", "bottom"],
        sizes: {
            mobile: { width: 0, height: 106 },
            mobile_landscape: { width: 362, height: 106 },
            default: { width: 404, height: 104 }
        }
    },

    outer: {
        positions: ["top", "bottom"],
        sizes: {
            mobile: { width: 0, height: 106 },
            mobile_landscape: { width: 0, height: 106 },
            default: { width: 0, height: 96 }
        }
    },

    bar_outer: {
        positions: ["top", "bottom"],
        sizes: {
            mobile: { width: 0, height: 106 },
            mobile_landscape: { width: 0, height: 106 },
            default: { width: 0, height: 96 }
        }
    },

    thin: {
        positions: ["top", "bottom"],
        sizes: {
            mobile_landscape: { width: 0, height: 56 },
            default: { width: 404, height: 48 }
        }
    },

    thin_outer: {
        positions: ["top", "bottom"],
        sizes: {
            mobile_landscape: { width: 0, height: 56 },
            default: { width: 0, height: 48 }
        }
    },

    vertical: {
        positions: ["left", "right"],
        sizes: {
            mobile_landscape: { width: 104, height: 276 },
            default: { width: 240, height: 400 }
        }
    },

    vertical_outer: {
        positions: ["left", "right"],
        sizes: {
            mobile_landscape: { width: 104, height: 0 },
            default: { width: 240, height: 400 }
        }
    }
};
